import * as $ from 'jquery';
import 'font-awesome/css/font-awesome.css';

$(document).ready(function() {
    $("input").keypress(function(event) {
        if (event.which == 13) {
            event.preventDefault();
            $('#loginform').submit();
        }
    });

    $('#loginform').submit( function() {
        var sOb = {}, usr=$('#email').val();
        sOb.username = usr;
        $('#ok').hide();
        $('#err').hide();
        $.ajax({
            url : "/login/reset-password/",
            type: "POST", method: "POST",
            contentType:"application/json",
            data : JSON.stringify(sOb),
            success: function(data, textStatus, jqXHR)
            {
                $('#pwdstarttxt').hide();
                if ( typeof data.done != 'undefined' ) {
                    $('#ok').show();
                    $('#loginform').hide();
                }else{
                    $('#err').html('Cannot send reset password email.').show();
                }
            }
        });
        return false;
    });
});
